import { loadResultsCookieByBaseUrl } from "components/Results/storeResultsData";
import { getCookieValue } from "./cookies";

export default function getAidFromCookie(newQuiz, baseUrl) {
  let { aid } = JSON.parse(getCookieValue("ww_assessment") || "{}");
  if (
    newQuiz.isUni3 ||
    newQuiz.isUni4 ||
    newQuiz.isClinical ||
    newQuiz.isUni5
  ) {
    aid = loadResultsCookieByBaseUrl(baseUrl)?.aid;
  }

  return aid;
}
